<template>
  <div id="app">
      <request-info />  
  </div>
</template>

<script>
  import RequestInfo from './components/RequestInfo';

  export default {
    name: "app",
    components: {
      RequestInfo,
    }
  }
</script>

<style>

</style>
